import {ColumnsType} from "antd/lib/table";
import {AddressDto} from "../../api";
import {CrudTableWrapperProps} from "digimuth-components/dist/components/crudTable/crudTable";
import {CrudTable, nameof} from "digimuth-components/dist";

export default function AddressesList(props: CrudTableWrapperProps<AddressDto>) {
    const columns: ColumnsType<AddressDto> = [
        {
            key: nameof<AddressDto>("street"),
            dataIndex: nameof<AddressDto>("street"),
            title: "Ulica"
        },
        {
            key: nameof<AddressDto>("buildingNumber"),
            dataIndex: nameof<AddressDto>("buildingNumber"),
            title: "Number budynku"
        },
        {
            key: nameof<AddressDto>("flatNumber"),
            dataIndex: nameof<AddressDto>("flatNumber"),
            title: "Numer mieszkania",
            render: (number: string | null) => number ?? "-"
        },
        {
            key: nameof<AddressDto>("postalCode"),
            dataIndex: nameof<AddressDto>("postalCode"),
            title: "Kod pocztowy"
        },
        {
            key: nameof<AddressDto>("city"),
            dataIndex: nameof<AddressDto>("city"),
            title: "Miasto"
        },
        {
            key: nameof<AddressDto>("vatId"),
            dataIndex: nameof<AddressDto>("vatId"),
            title: "NIP"
        },
        {
            key: nameof<AddressDto>("companyName"),
            dataIndex: nameof<AddressDto>("companyName"),
            title: "Nazwa firmy"
        },
    ];

    return <CrudTable
        data={props.data}
        onAddClicked={props.onAddClicked}
        onEditClicked={props.onEditClicked}
        onDeleteClicked={props.onDeleteClicked}
        isLoading={props.isLoading}
        columns={columns}
        deleteButtonTitle={"Usuń"}
        editButtonTitle={"Edytuj"}
        addButtonTitle={"+ Dodaj nowy adres"}
    />;
}
